/**
 * Bracketed richdown refs: [type|id] (id may contain ':') or legacy [type:id] (split on first ':').
 * Aligns with EntityRefParseable / server-side bracket parsing.
 */
export function richdownEntityRefRegex() {
  return /\[(profile|channel|emoji|spammer)(?:\|([^\]]+)|:([^\]]+))\](?:\(([^)]+)\))?/gi;
}

export function entityIdFromRichdownRefMatch(match) {
  return match[2] ?? match[3];
}

/** escape for double-quoted HTML attribute values */
export function escapeEntityAttr(value) {
  return String(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
